import Survey from "../models/SurveyModel";
import { getSurveyTemplates } from './CorrelatorService';
import { sortSourceColumnsByDisplayOrder } from '../common/Utilities';

const { marshall } = require("@aws-sdk/util-dynamodb");

export default class SurveyTemplateService  {

    scan = async () => {

        const optionalColumns = new Survey().optionalColumns;
        const requiredColumns = new Survey().requiredColumns;
        const templateDefaultColumns = new Survey().templateDefaultColumns;

        const parse = (data) => data.map((item) => {
            // Sort by the display order column
            item.columns.L = item.columns.L.sort(sortSourceColumnsByDisplayOrder);
            return {
                value: item.value.S,
                columns: optionalColumns(item.columns),
                requiredColumns: requiredColumns(item.columns),
                templateDefaultColumns: templateDefaultColumns(item.columns),
                label: item.label.S
            }
        });

        const templates = new Promise(function (resolve, reject) {
            var marshalled = [];
            getSurveyTemplates().then(res => res)
                .then((data) => {
                    data.forEach(function (item, i) {
                        marshalled.push(marshall(item));
                    });
                   // console.log(marshalled);
                    return resolve(parse(marshalled));
                })
                .catch(console.log)
        });

        return templates;
        
    };

}

